module.exports = __webpack_public_path__ + "img/ng_color.d08b6731.svg";